import { render } from "./AgentDialog.vue?vue&type=template&id=a978faf0"
import script from "./AgentDialog.vue?vue&type=script&lang=js"
export * from "./AgentDialog.vue?vue&type=script&lang=js"

import "./AgentDialog.vue?vue&type=style&index=0&id=a978faf0&lang=scss"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__